import { local as browserLocalStorage } from 'store2';
import { getCookie } from './lib/session/session';

export interface newrelicDataType {
   actionName?: string;
   userFunction: string;
   paymentName?: string;
   message?: string | any;
   resultCode?: string;
   type?: string;
   desktop?: boolean;
   cartId?: string;
   orderId?: string;
   isExpress?: boolean;
   deliveryMethod?: string;
   deliveryAddressId?:string;
   billingAddressId?:string;
   cartItemCount?: number;
   sessionId?: string;
   customerID?:string;
   customerEmail?:string;
   result?: string;
}

export function ensureNewRelicUserId(customerId?: string) {
    if (customerId && window.newrelic?.setUserId && !window.__nrUserIdSet) {
         window.newrelic.setUserId('user-' + customerId + '-v1.0');
         window.__nrUserIdSet = true;
     }
 }

function newRelicData(data: newrelicDataType) {
   const storeLocation = browserLocalStorage.get('store');
   const customerID = data.customerID ?? browserLocalStorage.get('customerId');
   const cartId = browserLocalStorage.get('cartId');
   const sessionId = getCookie('session.ID');
   const cartCount = browserLocalStorage.get('cartCount');
   const result = data.result ?? 'userLogs';

   if(window.newrelic) {
       window.newrelic.addPageAction(data.actionName, { cartId: cartId, store: storeLocation,  project: 'NC', paymentName: data.paymentName, function: data.userFunction,  message: data.message, resultCode: data.resultCode, type: data.type, desktop: data.desktop, orderId: data.orderId, isExpress: data.isExpress, deliveryMethod: data.deliveryMethod, deliveryAddressId: data.deliveryAddressId, billingAddressId: data.billingAddressId, cartItemsCount: cartCount, sessionId: sessionId, "user.id": customerID, customerEmail: data.customerEmail, result: result });
    }
}
export default newRelicData;